import React, { useState } from 'react'

import axios from 'axios';

import { IPermitDetail } from '../../../interfaces/services';

import { TextInput, CalenderInput } from '../../reusables/FormElements';

import DocumentMetadata from '../student/immigration/DocumentMetadata';
import ViewDocument from '../student/immigration/ViewDocument';

interface IPermitFormProps {
    studentId: number;
    data: IPermitDetail;
}

const PermitForm = (props: IPermitFormProps) => {
    const { studentId, data } = props;

    const { status, passport_number, permit_number, permit_type_description, lmia, issued, expire, submission_date, refused_date, document, company, case_type } = data;

    const [showDocument, setShowDocument] = useState(false);

    const onPreviewFile = () => {
        setShowDocument(true);
    }

    const onMinimizePreview = () => {
        setShowDocument(false);
    }

    const onDownloadFile = async (url: string) => {
        try {
            const response = await axios.get(url, { responseType: 'blob' });

            url = URL.createObjectURL(new Blob([response.data]));
            const link = window.document.createElement('a');
            link.href = url;
            link.download = document?.original || document?.display || 'document';
            window.document.body.appendChild(link);
            link.click();
            window.document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }

    return (
        <div className='immersion__details_form_inputs__container__deletable_forms__with__preview'>
            <div className='immersion__details_form_inputs__container__deletable_forms'>
                {document &&
                    <DocumentMetadata
                        fileName={document.original || document.display}
                        onPreviewFile={onPreviewFile}
                    />
                }
                <div className="immersion__details_form_inputs">
                    <TextInput
                        name="passport"
                        type="text"
                        label="Linked Passport"
                        required={true}
                        placeholder=""
                        value={passport_number}
                        onChange={() => { }}
                        errorMsg=""
                        read_only={true}
                    />
                    <TextInput
                        name="status"
                        type="text"
                        label="Status"
                        placeholder=""
                        value={status}
                        required={true}
                        onChange={() => { }}
                        errorMsg=""
                        read_only={true}
                    />
                    <TextInput
                        name="permitNumber"
                        type="text"
                        label="Number"
                        required={true}
                        placeholder=""
                        value={permit_number}
                        onChange={() => { }}
                        errorMsg=""
                        read_only={true}
                    />
                    <TextInput
                        name="permitType"
                        type="text"
                        label="Type"
                        required={true}
                        placeholder=""
                        value={permit_type_description}
                        onChange={() => { }}
                        errorMsg=""
                        read_only={true}
                    />
                    {
                        lmia
                            ? <TextInput
                                name="lmia"
                                type="text"
                                label="LMIA"
                                placeholder=""
                                value={lmia}
                                onChange={() => { }}
                                errorMsg=""
                                read_only={true}
                            />
                            : <TextInput
                                name="lmia"
                                type="text"
                                label="LMIA"
                                placeholder=""
                                value="LMIA not required"
                                onChange={() => { }}
                                errorMsg=""
                                read_only={true}
                            />
                    }
                    <TextInput
                        name="company"
                        type="text"
                        label="Company Name"
                        placeholder=""
                        required={true}
                        value={company}
                        onChange={() => { }}
                        errorMsg=""
                        read_only={true}
                    />
                    <TextInput
                        name="caseType"
                        type="text"
                        label="Case Type"
                        required={true}
                        placeholder=""
                        value={case_type}
                        onChange={() => { }}
                        errorMsg=""
                        read_only={true}
                    />
                    <CalenderInput
                        name="submissionDate"
                        label="Submission Date"
                        errorMsg=""
                        placeholder=""
                        format="mm/dd/yyyy"
                        onChange={() => { }}
                        value={submission_date || ''}
                        read_only={true}
                    />
                    <CalenderInput
                        name="refusedDate"
                        label="Decision Date"
                        errorMsg=""
                        placeholder=""
                        format="mm/dd/yyyy"
                        onChange={() => { }}
                        value={refused_date || ''}
                        read_only={true}
                    />
                    <CalenderInput
                        name="issueDate"
                        label="Issue Date"
                        errorMsg=""
                        placeholder=""
                        format="mm/dd/yyyy"
                        onChange={() => { }}
                        value={issued || ''}
                        read_only={true}
                    />
                    <CalenderInput
                        name="expiryDate"
                        label="Expiry Date"
                        errorMsg=""
                        placeholder=""
                        format="mm/dd/yyyy"
                        onChange={() => { }}
                        value={expire || ''}
                        read_only={true}
                    />
                </div>
            </div>
            {showDocument && document &&
                <ViewDocument
                    studentId={studentId}
                    document={document}
                    onMinimizePreview={onMinimizePreview}
                    onDownloadFile={onDownloadFile}
                />
            }
        </div>
    )
}

export default PermitForm;